import { AlertColor } from "@mui/material";
import {
  ESenderRole,
  IContractDetailsResponseData,
} from "../../../setup/api/services/contract/models";
import { IWithdrawDetailsBank } from "../../../setup/api/services/withdraws/models";

export enum SelectedPaymentType {
  BANK = "BANK",
  SINGLE_VIEW = "SINGLE_VIEW",
  TABBY = "TABBY",
  MOYASAR = "MOYASAR",
  NEO = "NEO",
  TAMARA = "TAMARA",
  OTHER_CONTRACT = "OTHER_CONTRACT",
  NONE = "NONE",
}
export interface SnackBarStates {
  title: string;
  color: AlertColor;
}
export interface ConfirmationMethodProps {
  selectionType: SelectedPaymentType;
  isManualRefund?: boolean;
}
export interface ConfirmationMethodResult {
  snackBarStates?: SnackBarStates;
  shouldClose?: boolean;
  success: boolean;
}

type AmountType = number | string | undefined;

export interface BankDetails {
  beneficiaryName?: string;
  currency?: string;
  iban?: string;
  swiftCode?: string;
  bank?: {
    id?: number;
    arabicName?: string;
    englishName?: string;
    abbreviation?: string;
    swiftCode?: string;
  };
}
export interface PaymentMethodModalProps {
  open: boolean;
  onClose: () => void;
  contract?: IContractDetailsResponseData;
  userType?: ESenderRole;
  userId?: string | number;
  amount: AmountType;
  setAmount: (amount: AmountType) => void;
  gatewayPaymentId?: string;
  setGatewayPaymentId: (gatewayPaymentId?: string) => void;
  targetContractDomainId?: string;
  setTargetContractDomainId: (targetContractDomainId?: string) => void;
  /**
   * Should handle the confirmation of the payment request
   * - Prepares the request based on selected payment method
   * - Handles different payment flows (refund, cashout, manual cashout)
   * - returns data for success/error messages and updating UI accordingly
   */
  onConfirm: (
    params: ConfirmationMethodProps
  ) => Promise<ConfirmationMethodResult>;
  paymentAmount: number;
  transactionDate: Date | null;
  setTransactionDate: (transactionDate: Date | null) => void;
  bankDetails?: IWithdrawDetailsBank;
  showOtherContractOption?: boolean;
  isTargetContractLocked?: boolean;
}
